export default [
  {
    path: '/activity-20260826-main',
    component: () => import('./Page.vue'),
    meta: { title: '幸运航海', id: 40 },
  },
  {
    path: '/activity-20260826-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '幸运航海-规则', id: 40 },
  },
]
